interface AudioInputModelLike {
  provider_name?: string;
  audio_input_supported?: boolean | null;
  direct_audio_input_supported?: boolean | null;
  transcription_supported?: boolean | null;
  audio_output_supported?: boolean | null;
}

interface AudioInputAgentLike {
  model?: AudioInputModelLike | null;
  stt_model?: AudioInputModelLike | null;
  tts_model?: AudioInputModelLike | null;
}

export function isAudioInputSupported(model?: AudioInputModelLike | null): boolean {
  return model?.direct_audio_input_supported === true
    || model?.transcription_supported === true
    || model?.audio_input_supported === true;
}

export function isDirectAudioInputSupported(model?: AudioInputModelLike | null): boolean {
  return model?.direct_audio_input_supported === true;
}

export function isTranscriptionSupported(model?: AudioInputModelLike | null): boolean {
  return model?.transcription_supported === true;
}

export function canAgentAcceptAudio(agent?: AudioInputAgentLike | null): boolean {
  if (!agent) return false;
  return isDirectAudioInputSupported(agent.model) || isTranscriptionSupported(agent.stt_model);
}

export function isAudioOutputSupported(model?: AudioInputModelLike | null): boolean {
  return model?.audio_output_supported === true;
}

export function canAgentSpeakAudio(agent?: AudioInputAgentLike | null): boolean {
  if (!agent) return false;
  return isAudioOutputSupported(agent.tts_model);
}

export function getAudioInputDisabledReason(model?: AudioInputModelLike | null): string {
  if (!model) {
    return 'Voice input is unavailable until model details finish loading.';
  }
  const providerName = model.provider_name || 'this model';
  return `Voice input is not available for ${providerName} in this chat yet. Configure an audio-capable STT model or send a transcript.`;
}

export function getAgentAudioInputDisabledReason(agent?: AudioInputAgentLike | null): string {
  if (!agent) {
    return 'Voice input is unavailable until agent details finish loading.';
  }
  if (canAgentAcceptAudio(agent)) {
    return '';
  }
  return getAudioInputDisabledReason(agent.model);
}

export function getAgentAudioOutputDisabledReason(agent?: AudioInputAgentLike | null): string {
  if (!agent) {
    return 'Voice output is unavailable until agent details finish loading.';
  }
  if (canAgentSpeakAudio(agent)) {
    return '';
  }
  return 'Voice output requires an audio-output-capable TTS model configured on this agent.';
}
